<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="CT" id="_idParaDest-7"><a id="_idTextAnchor001"></a>CONTENTS</p>
<p class="BTspace ParaOverride-10"><a href="#/97808021580177#_idTextAnchor002"><span class="CharOverride-7">CARDIFF, BY THE SEA</span></a></p>
<p class="BTspace ParaOverride-11"><a href="#/978080215801734#_idTextAnchor003"><span class="CharOverride-7">MIAO DAO</span></a></p>
<p class="BTspace ParaOverride-11"><a href="#/978080215801751#_idTextAnchor004"><span class="CharOverride-7">PHANTOMWISE: 1972</span></a></p>
<p class="BTspace ParaOverride-11"><a href="#/978080215801763#_idTextAnchor005"><span class="CharOverride-7">THE SURVIVING CHILD</span></a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780802158017-6.vue?75bcdf33